function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInformation = function SvgInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13 21.3c-4.6 0-8.3-3.7-8.3-8.3S8.4 4.7 13 4.7s8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3m0-15a6.7 6.7 0 0 0 0 13.4c3.7 0 6.6-3 6.6-6.7S16.7 6.3 13 6.3m0 5.7c.6 0 1 .5 1 1v3.3c0 .6-.4 1-1 1s-1.1-.5-1.1-1V13c0-.6.5-1 1.1-1m0-3.2c-.6 0-1.1.5-1.1 1 0 .6.5 1 1.1 1s1-.5 1-1-.4-1-1-1",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgInformation;